import React from 'react';
import { TimezoneForm } from './TimezoneForm';

interface AddEditTimezoneModalProps {
  formMode: 'add' | 'edit';
  editingTimezone: { value: string; label: string } | null;
  initialDisplayName: string;
  timezoneOptions: { value: string; label: string }[];
  onSubmit: (timezone: { value: string; label: string }, displayName: string) => void;
  onCancel: () => void;
  filterOption: (option: { value: string; label: string }, inputValue: string) => boolean;
}

const AddEditTimezoneModal: React.FC<AddEditTimezoneModalProps> = ({
  formMode,
  editingTimezone,
  initialDisplayName,
  timezoneOptions,
  onSubmit,
  onCancel,
  filterOption,
}) => {
  return (
    <div className="modal show d-block" tabIndex={-1} role="dialog">
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{formMode === 'add' ? 'Add Timezone' : 'Edit Timezone'}</h5>
            <button type="button" className="close" aria-label="Close" onClick={onCancel}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <TimezoneForm
              timezoneOptions={timezoneOptions}
              initialTimezone={editingTimezone}
              initialDisplayName={initialDisplayName}
              onSubmit={onSubmit}
              onCancel={onCancel}
              filterOption={filterOption}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddEditTimezoneModal;
